import { queryKeys } from './useQueryPaymentSource'
import { useQueryClientUtils } from '../useQueryClientUtils'
import { useFetchPaymentSource } from './useFetchPaymentSource'

const create = () => {
  const { create } = useFetchPaymentSource()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: create,
    onMutate: (variables) => {
      cancelQueries([queryKeys.all(variables).queryKey])
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([queryKeys.all(variables).queryKey])
    },
  })
}

const drop = () => {
  const { drop } = useFetchPaymentSource()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: drop,
    onMutate: (variables) => {
      cancelQueries([queryKeys.all(variables).queryKey])
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([queryKeys.all(variables).queryKey])
    },
  })
}

export const useMutationPaymentSource = {
  create,
  drop,
}
